// extracted by mini-css-extract-plugin
module.exports = {"review":"i9","value":"i-","name":"i_","isRental":"ja"};